import React, { useState, useEffect } from "react";
import Donut from "../Components/Donut";
import "./CustomerDashboard.css";
import LineChart from "../Components/LineChart";
import { PieChart, Pie } from "recharts";
import { Line } from "react-chartjs-2";
import { Button, Dropdown, Nav, Tab, Tabs } from "react-bootstrap";
import AlertDeviceLogo from "../../assets/images/AlertDevice.svg";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { environment } from "../../environment";
import { colors } from "@mui/material";
import { dashboardService } from "../services/userDashboardService";
import Select from "react-select";
import DatePicker from "react-datepicker";
// const [loader, setLoader] = useState(true);

import "react-datepicker/dist/react-datepicker.css";
import CsvDownload from "react-json-to-csv";
import { FaSmog, FaWind, FaCloud } from "react-icons/fa";

let dap_deviceId = null;

const CustomerDashboard = () => {
  const history = useHistory();
  const [key, setKey] = useState("dashboard");
  const [time, setTime] = useState(new Date());
  const [selectedValue, setselectedValue] = useState("");
  const [dap_deviceList, setListDevice] = useState([]);
  const [dap_selectedDeviceName, setSelectedDeviceName] = useState("");
  const [dap_pm10, setpm10] = useState(["00"]);
  const [dap_pm25, setpm25] = useState(["00"]);
  const [dap_co2, setCo2] = useState(["00"]);
  const [dap_tvoc, setTvoc] = useState(["00"]);
  const [dap_Temp, setTemp] = useState(["00"]);
  const [dap_Humy, setHumy] = useState(["00"]);
  const [AQI, setAQI] = useState([]);
  const [AQIColor, setAQIColor] = useState(["#8A93A3"]);
  const [AQIquality, setAQIquality] = useState([]);
  const [RmName, setRmName] = useState([]);
  const [ResData, setResData] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [PM25, setPM25] = useState([]);
  const [PM10, setPM10] = useState([]);
  const [CO2, setCO2] = useState([]);
  const [TVOC, setTVOC] = useState([]);
  const [TEMP, setTEMP] = useState([]);
  const [HUMY, setHUMY] = useState([]);
  const [data, setdata] = useState({});
  // const [Option, setOption] = useState([]);
  const [startTs, setStartTs] = useState();
  const [endTs, setEndTs] = useState();
  const [searchLoading, setSearchLoading] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [convertCsv, setConvertCsv] = useState(false);

  const [iaqData, setIaqData] = useState([]);
  const [CO2spikeData, setCO2SpikeData] = useState([]);
  const [PM25spikeData, setPM25SpikeData] = useState([]);
  const [PM10spikeData, setPM10SpikeData] = useState([]);
  const [TEMPspikeData, setTEMPSpikeData] = useState([]);
  const [TVOCspikeData, setTVOCSpikeData] = useState([]);
  const [lastUpdated, setLastUpdated] = useState("");
  const [deviceId, setDeviceId] = useState(null);

  let userDetails = {};

  let deviceDataArray = [];

  let iaqDataArray = [];

  let CO2spikeDataArray = [];

  let PM25spikeDataArray = [];

  let PM10spikeDataArray = [];

  let TVOCspikeDataArray = [];

  let TEMPspikeDataArray = [];

  const headers = [
    { label: "ts", key: "TIMESTAMP" },
    { label: "time", key: "TIME" },
    { label: "iaq value", key: "IAQ" },
    { label: "co2 value", key: "CO2[PPM]" },
    { label: "pm2.5 value", key: "PM2.5[micrograms/m3]" },
    { label: "pm 10 value", key: "PM10[micrograms/m3]" },
    { label: "tvoc value", key: "TVOC[PPB]" },
    { label: "temp value", key: "TEMPERATURE[celsius]" },
    { label: "rh value", key: "HUMIDITY[percentage]" },
    { label: "lat", key: "LAT" },
    { label: "lon", key: "LON" },
    { label: "device", key: "device" },
  ];

  const spike_headers = [
    { label: "ts", key: "TIMESTAMP" },
    { label: "time", key: "TIME" },
    { label: "iaq value", key: "IAQ" },
    { label: "co2 value", key: "CO2_ppm" },
    { label: "pm2.5 value", key: "PM25_ppm" },
    { label: "pm 10 value", key: "PM10_ppm" },
    { label: "tvoc value", key: "TVOC_ppb" },
    { label: "temp value", key: "TEMPERATURE_Celsius" },
    { label: "rh value", key: "HUMIDITY_rh" },
    { label: "device", key: "device" },
  ];

  const Greeting = () => {
    const [greeting, setGreeting] = useState("");

    useEffect(() => {
      // history.push('#dashboard')
      console.log("history", history);

      const time = new Date().getHours();

      if (time >= 5 && time < 12) {
        setGreeting("Morning");
      } else if (time >= 12 && time < 18) {
        setGreeting("Afternoon");
      } else {
        setGreeting("Evening");
      }
    }, []);

    return { greeting };
  };

  function Time() {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
      const interval = setInterval(() => {
        setTime(new Date());
      }, 1000);
      return () => clearInterval(interval);
    }, []);
  }

  useEffect(() => {
    let userId = localStorage.getItem("userDetails");
    userDetails = localStorage.getItem("userDetails");
    userDetails = JSON.parse(userDetails);
    getDevicePerUser();
    let sd = new Date().toISOString().split("T")[0];
    // sd.setUTCHours(0, 0, 0, 0)
    setStartTs(sd);

    let ed = new Date().toISOString().split("T")[0];
    setEndTs(ed);

    console.log("date-default start", sd);
    console.log("date-default end", ed);
    // getDashboardDataFirstTime();
    // changeDonutData()
  }, []);
  // function SelectOne(e) {
  //     setselectedValue(e.target.value);
  // }
  const changeDevice = (d) => {
    console.log(d.target.value);

    const selectedDevice = dap_deviceList.find(
      (device) => device.deviceId === d.target.value
    );
    if (selectedDevice) {
      setRmName(selectedDevice.deviceAlias);
    }

    //  setSelectedDeviceName(device.label);
    console.log("Hii");
    // dashboardService.sendMessage(device.value);
    getDashboardDataFirstTime(d.target.value);
    // getDashboardData();
    // GetData();
  };
  const changeDeviceDownload = (d) => {
    console.log(d.value);
    setSelectedDevice(d.value);
  };

  const changeFromDate = (e) => {
    console.log(e.target.value);
    setStartTs(e.target.value);
  };
  const changeToDate = (e) => {
    console.log(e.target.value);
    setEndTs(e.target.value);
  };

  const getDevicePerUser = () => {
    let token = localStorage.getItem("token");
    let CustomerId = JSON.parse(localStorage.getItem("userDetails"));
    let customer_ID = CustomerId.data.customerId.id;
    console.log(CustomerId.data.customerId.id);
    // setLoader(true);
    axios
      .post(
        environment.dap_url + "dapDevice/getDeviceByOwnerId",
        { customerId: customer_ID },
        { headers: { "X-Authorization": "Bearer " + token } }
      )
      .then((res) => {
        console.log(res);
        console.log(res.data.deviceId);
        getDashboardDataFirstTime(res.data[0].deviceId);
        setDeviceId(res.data[0].deviceId);
        setListDevice(res.data);
        console.log(res.data);

        let device_name = res.data[0].deviceAlias;
        if (device_name) {
          setRmName(device_name);
        }
        localStorage.setItem("listDevices", JSON.stringify(res.data.data));
      })
      .catch((err) => {
        console.log(err.Error);
        // setLoader(false);
        if (err?.response?.status == 401) {
          console.log("jhgs");
        }
      });
  };
  const getDashboardDataFirstTime = (d) => {
    // console.log(dashboardService.getMessage());
    dashboardService.getMessage().subscribe((deviceId) => {
      console.log(deviceId);
      dap_deviceId = deviceId;
    });
    let token = localStorage.getItem("token");
    // setLoader(true);
    // https://dap.centralindia.cloudapp.azure.com/api/plugins/telemetry/DEVICE/0b199a90-f686-11eb-aeab-6338f3fa1c68/values/timeseries?keys=pm25,pm10,co2&startTs=1628200000000&endTs=1628426783314&interval=60000&limit=100
    axios
      .get(
        environment.apiUrl +
        "plugins/telemetry/DEVICE/" +
        d +
        "/values/timeseries?keys=iaq,pm25,pm10,co2,tvoc,temp,rh,lat,lon,bat,mode&startTs=" +
        (Date.now() - 10 * 60 * 60 * 5000) +
        "&endTs=" +
        Date.now() +
        "&interval=60000&limit=20",
        { headers: { "X-Authorization": "Bearer " + token } }
      )
      .then((res) => {
        let i = 0;
        console.log("first time", Object.keys(res.data).length);
        console.log("DATA", res.data.pm25[0].ts);
        let date = new Date(res.data.iaq[0].ts);
        let formattedDate = date.toLocaleString('en-GB', {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
        });
        setLastUpdated(formattedDate);
        setResData(res);
        const Aqichart = [
          { name: "Aqichart", students: 400 }, //for making the chart only
        ];
        setdata(Aqichart);

        setAQI(
          Object.keys(res.data).length == "0" ? "0 0" : res.data.iaq[0].value
        );
        if (Object.keys(res.data).length == "0") {
          setpm25("0 0");
          setpm10("0 0");
          setCo2("0 0");
          setTvoc("0 0");
          setTemp("0 0");
          setHumy("0 0");
        } else {
          setpm25(res.data.pm25[0].value);
          setpm10(res.data.pm10[0].value);
          setCo2(res.data.co2[0].value);
          setTvoc(res.data.tvoc[0].value);
          setTemp(res.data.temp[0].value);
          setHumy(res.data.rh[0].value);
        }

        let AqiQuality = {};
        let AqiQualityColor = {};

        if (Object.keys(res.data).length == 0) {
          AqiQualityColor = "#8A93A3";
          AqiQuality = "____";
        } else {
          if (res.data.iaq[0].value <= 100) {
            AqiQuality = "GOOD";
            AqiQualityColor = "#00B252";
          } else if (
            res.data.iaq[0].value > 100 &&
            res.data.iaq[0].value <= 200
          ) {
            AqiQuality = "MODERATE";
            AqiQualityColor = "#DF8C0D";
          } else {
            AqiQuality = "POOR";
            AqiQualityColor = "#D60000";
          }
        }

        setAQIquality(AqiQuality);
        setAQIColor(AqiQualityColor);
        let pm10Val = [];
        let pm25Val = [];
        let CO2VAl = [];
        let TVOCVal = [];
        // let TempVal = [];
        // let HumyVal = [];

        let pm10Tm = [];
        let pm25Tm = [];
        let CO2Tm = [];
        let TVOCTm = [];
        // let TempTm = [];
        // let HumyTm = [];


        if (Object.keys(res.data).length == "0") {
          pm25Val.push([]);
          pm10Val.push([]);
          CO2VAl.push([]);
          TVOCVal.push([]);
          // TempVal.push([]);
          // HumyVal.push([]);

          pm25Tm.push([]);
          pm10Tm.push([]);
          CO2Tm.push([]);
          TVOCTm.push([]);
          // TempTm.push([]);
          // HumyTm.push([]);
        } else {
          for (let i = 9; i >= 0; i--) {

            console.log(res.data.pm10[i].value);

            pm25Val.push(res.data.pm25[i].value);
            pm10Val.push(res.data.pm10[i].value);
            CO2VAl.push(res.data.co2[i].value);
            TVOCVal.push(res.data.tvoc[i].value*1000 );
            // TempVal.push(res.data.temp[i].value);
            // HumyVal.push(res.data.rh[i].value);

            const pm10_timestamp = res.data.pm10[i].ts;
            const pm10_date = new Date(pm10_timestamp);
            const pm10_hour = pm10_date.getHours();
            const pm10_minute = pm10_date.getMinutes();
            const formatted_pm10_minute = pm10_minute < 10 ? '0' + pm10_minute : pm10_minute;
            pm10Tm.push(pm10_hour + ':' + formatted_pm10_minute);
            
            const PM25_timestamp = res.data.pm25[i].ts;
            const PM25_date = new Date(PM25_timestamp);
            const PM25_hour = PM25_date.getHours();
            const PM25_minute = PM25_date.getMinutes();
            const formatted_PM25_minute = PM25_minute < 10 ? '0' + PM25_minute : PM25_minute;
            pm25Tm.push(PM25_hour + ':' +formatted_PM25_minute);

            const co2_timestamp = res.data.co2[i].ts;
            const co2_date = new Date(co2_timestamp);
            const co2_hour = co2_date.getHours();
            const co2_minute = co2_date.getMinutes();
            const formatted_co2_minute = co2_minute < 10 ? '0' +co2_minute : co2_minute;
            CO2Tm.push(co2_hour + ':' +formatted_co2_minute);

            const tvoc_timestamp = res.data.tvoc[i].ts;
            const tvoc_date = new Date(tvoc_timestamp);
            const tvoc_hour = tvoc_date.getHours();
            const tvoc_minute = tvoc_date.getMinutes();
            const formatted_tvoc_minute = tvoc_minute < 10 ? '0' +tvoc_minute : tvoc_minute;
            TVOCTm.push(tvoc_hour + ':' +formatted_tvoc_minute);

            // const temp_timestamp = res.data.temp[i].ts;
            // const temp_date = new Date(temp_timestamp);
            // const temp_hour = temp_date.getHours();
            // const temp_minute = temp_date.getMinutes();
            // const formatted_temp_minute = temp_minute < 10 ? '0' +temp_minute : temp_minute;
            // TempTm.push(temp_hour + ':' +formatted_temp_minute);

            // const rh_timestamp = res.data.rh[i].ts;
            // const rh_date = new Date(rh_timestamp);
            // const rh_hour = rh_date.getHours();
            // const rh_minute = rh_date.getMinutes();
            // const formatted_rh_minute = rh_minute < 10 ? '0' +rh_minute : rh_minute;
            // HumyTm.push(rh_hour + ':' +formatted_rh_minute);

          }
        }
        console.log("datag", pm10Tm);
        setPM25({
          labels: (pm25Tm),
          datasets: [
            {
              label: "PM 2.5 ",
              data: pm25Val,
              fill: false,
              borderWidth: 2,
              backgroundColor: "#49B7B6",
              borderColor: "#49B7B6",
            },
          ],
        });

        setPM10({
          // x-axis label values
          labels:(pm10Tm),
          datasets: [
            {
              label: "PM 10 ",
              data: pm10Val,
              fill: false,
              borderWidth: 2,
              backgroundColor: "#49B7B6",
              borderColor: "#49B7B6",
              responsive: true,
            },
          ],
        });
        setCO2({
          // x-axis label values
          labels: (CO2Tm),
          datasets: [
            {
              label: "CO2 ",
              data: CO2VAl,
              fill: false,
              borderWidth: 2,
              backgroundColor: "#49B7B6",
              borderColor: "#49B7B6",
              responsive: true,
            },
          ],
        });
        setTVOC({
          // x-axis label values
          labels: (TVOCTm),
          datasets: [
            {
              label: "TVOC ",
              data: TVOCVal,
              fill: false,
              borderWidth: 2,
              backgroundColor: "#49B7B6",
              borderColor: "#49B7B6",
              responsive: true,
            },
          ],
        });
        // setTEMP({
        //   // x-axis label values
        //   labels: (TempTm),
        //   datasets: [
        //     {
        //       label: "Temperature ",
        //       data: TempVal,
        //       fill: false,
        //       borderWidth: 2,
        //       backgroundColor: "#49B7B6",
        //       borderColor: "#49B7B6",
        //       responsive: true,
        //     },
        //   ],
        // });
        // setHUMY({
        //   // x-axis label values
        //   labels: (HumyTm),
        //   datasets: [
        //     {
        //       label: "Humidity ",
        //       data: HumyVal,
        //       fill: false,
        //       borderWidth: 2,
        //       backgroundColor: "#49B7B6",
        //       borderColor: "#49B7B6",
        //       responsive: true,
        //     },
        //   ],
        // });

        // setOption({
        //   legend: {
        //     display: false,
        //   },
        // });
        localStorage.setItem("latestTelemetryData", JSON.stringify(res.data));
      })
      .catch((err) => {
        console.log(err.Error);
      });
// written by om , only for temp and humidity
    axios
      .get(
        environment.apiUrl +
    "plugins/telemetry/DEVICE/" +
    d +
    "/values/timeseries?keys=temp,rh" +
    "&startTs=" +
    (Date.now() - 48 * 60 * 60 * 1000) +  
    "&endTs=" +
    Date.now() +
    "&interval=14400000&limit=1000",
  { headers: { "X-Authorization": "Bearer " + token } }
)
      .then((res) => {

        console.log("i am getting this data om ", res.data);
        let i = 0;       
        
        let TempVal = [];
        let HumyVal = [];

        let TempTm = [];
        let HumyTm = [];


        if (Object.keys(res.data).length == "0") {

          TempVal.push([]);
          HumyVal.push([]);

          TempTm.push([]);
          HumyTm.push([]);
        } else {
          const mostRecentTime = res.data.temp[0].ts;
    
    for (let hoursBack = 0; hoursBack < 10; hoursBack++) {
        const targetTime = mostRecentTime - (hoursBack* 15 * 60 * 1000); // hoursBack in milliseconds
        
        // Find the data point closest to this target time
        let closestIndex = -1;
        let smallestDiff = Infinity;
        
        for (let i = 0; i < res.data.temp.length; i++) {
            const diff = Math.abs(res.data.temp[i].ts - targetTime);
            if (diff < smallestDiff) {
                smallestDiff = diff;
                closestIndex = i;
            }
        }
        
        // If we found a close enough point (within 5 minutes)
        if (closestIndex !== -1 && smallestDiff < (5 * 60 * 1000)) {
            const dataPoint = res.data.temp[closestIndex];
            const rhPoint = res.data.rh[closestIndex];
            
            TempVal.push(dataPoint.value);
            HumyVal.push(rhPoint.value);
            
            const date = new Date(dataPoint.ts);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const formattedTime = `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
            
            TempTm.push(formattedTime);
            HumyTm.push(formattedTime);
        }
    }
    
          // Reverse to show oldest first
          TempVal.reverse();
          HumyVal.reverse();
          TempTm.reverse();
          HumyTm.reverse();
    
        }

        setTEMP({
          // x-axis label values
          labels: (TempTm),
          datasets: [
            {
              label: "Temperature ",
              data: TempVal,
              fill: false,
              borderWidth: 2,
              backgroundColor: "#49B7B6",
              borderColor: "#49B7B6",
              responsive: true,
            },
          ],
        });
        setHUMY({
          // x-axis label values
          labels: (HumyTm),
          datasets: [
            {
              label: "Humidity ",
              data: HumyVal,
              fill: false,
              borderWidth: 2,
              backgroundColor: "#49B7B6",
              borderColor: "#49B7B6",
              responsive: true,
            },
          ],
        });
      })
      .catch((err) => {
        console.log(err.Error);
      });
  };

  var UserName = JSON.parse(localStorage.getItem("userDetails")).data.firstName;
  var Device = "10";
  // console.log(dap_deviceList);
  const searchData = () => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let customerId = userDetails.data.customerId.id;
    let tenantId = userDetails.data.tenantId.id;
    let alias = selectedDevice;
    if (alias == "" || alias == undefined) {
      alert("Please select any device location");
      return;
    }
    if (new Date(startTs) > new Date(endTs)) {
      alert("End date can't be less than the start date");
    }
    let startDate = new Date(startTs).toISOString();
    let endDate = "";
    let currentDate = new Date(Date.now()).toISOString().split("T")[0];
    if (currentDate == endTs) {
      let eDate = new Date(endTs);
      let curr_h = new Date().getHours();
      let curr_m = new Date().getMinutes();
      let curr_s = new Date().getSeconds();
      eDate.setUTCHours(curr_h, curr_m, curr_s, 0);
      endDate = eDate.toISOString();
    } else {
      let eDate = new Date(endTs);
      eDate.setUTCHours(23, 59, 59, 0);
      endDate = eDate.toISOString();
    }

    console.log({ customerId, tenantId, alias, startDate, endDate });
    setSearchLoading(true);
    setConvertCsv(true);
    let searchURL =
      environment.dap_url +
      "external_api/customer/" +
      customerId +
      "/device/" +
      alias +
      "/download";

    axios
      .post(searchURL, { tenant_id: tenantId, start: startDate, end: endDate })
      .then((res) => {
        setSearchLoading(false);
        setConvertCsv(false);
        setShowDownload(true);
        console.log(res.status);
        if (res.data.iaq.length == 0) {
          alert("no data found");
          setShowDownload(false);
          return;
        }
        res.data.iaq.forEach((element) => {
          //iaqDataArray.push({ ts: element.ts, iaq_value: element.value });

          let date = new Date(element.ts);
          console.log("date and time in your timezone", date.toISOString());
          let dateArr = date.toISOString().split("T");
          let d = dateArr[0].split("-");
          let t = dateArr[1].split(".")[0];
          let iaqtime = d[2] + "/" + d[1] + "/" + d[0] + " " + t;
          iaqDataArray.push({
            TIMESTAMP: element.ts,
            DATE_TIME: iaqtime,
            IAQ: element.value,
          });
        });
        console.log(res.data.co2);

        res.data.co2.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["CO2[PPM]"] = element.value;
            }
          });

          if (element.value == 0 || element.value > 1000) {
            console.log(new Date(element.ts).getTime());
            let dateCo2 = new Date(element.ts);
            let dateArrCo2 = dateCo2.toISOString();
            let dCo2 = dateArrCo2[0].split("-");
            let tCo2 = dateArrCo2[1].split(".")[0];
            let co2time = dCo2[2] + "/" + dCo2[1] + "/" + dCo2[0] + " " + tCo2;
            CO2spikeDataArray.push({
              DATE_TIME: co2time,
              CO2_ppm: element.value,
            });
          }
        });

        res.data.pm25.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["PM2.5[micrograms/m3]"] = element.value;
            }
          });
          if (element.value > 200) {
            let datePM25 = new Date(element.ts);
            let dateArrPM25 = datePM25.toISOString();
            let dPM25 = dateArrPM25[0].split("-");
            let tPM25 = dateArrPM25[1].split(".")[0];
            let pm25time =
              dPM25[2] + "/" + dPM25[1] + "/" + dPM25[0] + " " + tPM25;
            PM25spikeDataArray.push({
              DATE_TIME: pm25time,
              PM_2_5_ppm: element.value,
            });
          }
        });

        res.data.pm10.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["PM10[micrograms/m3]"] = element.value;
            }
          });

          if (element.value > 200) {
            let datePM10 = new Date(element.ts);
            let dateArrPM10 = datePM10.toISOString();
            let dPM10 = dateArrPM10[0].split("-");
            let tPM10 = dateArrPM10[1].split(".")[0];
            let pm10time =
              dPM10[2] + "/" + dPM10[1] + "/" + dPM10[0] + " " + tPM10;
            PM10spikeDataArray.push({
              DATE_TIME: pm10time,
              PM_10_ppm: element.value,
            });
          }
        });

        res.data.temp.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["TEMPERATURE[celsius]"] = element.value;
            }
          });

          if (element.value > 50) {
            let dateTemp = new Date(element.ts);
            let dateArrTemp = dateTemp.toISOString();
            let dTemp = dateArrTemp[0].split("-");
            let tTemp = dateArrTemp[1].split(".")[0];
            let temptime =
              dTemp[2] + "/" + dTemp[1] + "/" + dTemp[0] + " " + tTemp;
            TEMPspikeDataArray.push({
              DATE_TIME: temptime,
              TEMP: element.value,
            });
          }
        });

        res.data.rh.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["HUMIDITY[percentage]"] = element.value;
            }
          });
        });

        res.data.tvoc.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["TVOC[PPB]"] = element.value;
            }
          });
          if (element.value > 10) {
            let dateTVOC = new Date(element.ts);
            let dateArrTVOC = dateTVOC.toISOString();
            let dTVOC = dateArrTVOC[0].split("-");
            let tTVOC = dateArrTVOC[1].split(".")[0];
            let tvoctime =
              dTVOC[2] + "/" + dTVOC[1] + "/" + dTVOC[0] + " " + tTVOC;
            TVOCspikeDataArray.push({
              DATE_TIME: tvoctime,
              TVOC_ppm: element.value,
            });
          }
        });

        res.data.device.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item.device = element.device_label;
            }
          });
          if (element.value > 10) {
            let dateDevice = new Date(element.ts);
            let dateArrDevice = dateDevice.toISOString();
            let dDevice = dateArrDevice[0].split("-");
            let tDevice = dateArrDevice[1].split(".")[0];
            let devicetime =
              dDevice[2] + "/" + dDevice[1] + "/" + dDevice[0] + " " + tDevice;
            deviceDataArray.push({
              DATE_TIME: devicetime,
              device: element.value,
            });
          }
        });

        console.log(iaqDataArray);
        console.log(CO2spikeDataArray);
        setIaqData(iaqDataArray);
        setCO2SpikeData(CO2spikeDataArray);
        setTEMPSpikeData(TEMPspikeDataArray);
        setPM25SpikeData(PM25spikeDataArray);
        setPM10SpikeData(PM10spikeDataArray);
        setTEMPSpikeData(TEMPspikeDataArray);
        setTVOCSpikeData(TVOCspikeDataArray);
      })
      .catch((error) => {
        console.log(error.statusCode);
        setShowDownload(false);
      });
  };

  const csvReport = {
    data: iaqData,
    headers: headers,
    filename: selectedDevice + ".csv",
  };

  const CO2SpikeReport = {
    data: CO2spikeData,
    headers: spike_headers,
    filename: `${selectedDevice}_CO2_spikes` + ".csv",
  };

  const PM25SpikeReport = {
    data: PM25spikeData,
    headers: spike_headers,
    filename: `${selectedDevice}_PM2.5_spikes` + ".csv",
  };

  const PM10SpikeReport = {
    data: PM10spikeData,
    headers: spike_headers,
    filename: `${selectedDevice}_PM10_spikes` + ".csv",
  };

  const TEMPSpikeReport = {
    data: TEMPspikeData,
    headers: spike_headers,
    filename: `${selectedDevice}_TEMP_spikes` + ".csv",
  };

  const TVOCSpikeReport = {
    data: TVOCspikeData,
    headers: spike_headers,
    filename: `${selectedDevice}_TVOC_spikes` + ".csv",
  };

  const pollutantRanges = {
  pm25: { min: 0, max: 300, stepSize: 20 },
  pm10: { min: 0, max: 500, stepSize: 50 },
  co2: { min: 0, max: 5000, stepSize: 500 },
  tvoc: { min: 0, max: 1600, stepSize: 200 },
  temp: { min: -100, max: 70, stepSize: 10 },
  humy: { min: 0, max: 100, stepSize: 20 }
};

// Add this function to your component
const getChartOptions = (pollutantType) => {
  const range = pollutantRanges[pollutantType];
  
  return {
    legend: {
      display: false,
    },
    scales: {
      yAxes: [{
        ticks: {
          min: range.min,
          max: range.max,
          stepSize: range.stepSize,
          callback: function(value) {
            return value;
          }
        }
      }],
      xAxes: [{
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10
        }
      }]
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem) {
          return tooltipItem.yLabel;
        }
      }
    }
  };
};

  const [city, setCity] = useState("");
  const [outdoorAQI, setOutdoorAQI] = useState(null);
  const [outdoorPM10, setOutdoorPM10] = useState(null);
  const [outdoorPM25, setOutdoorPM25] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (userData && userData.city) {
      setCity(userData.city);
    }
  }, []);

  // Fetch outdoor AQI data when city is available
 useEffect(() => {
    const fetchAQI = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token"); // Assuming you saved token as "token"

        const response = await axios.get(environment.dap_url +`outdoorPollution/getAQIByCity?city=${encodeURIComponent(city)}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setOutdoorAQI(response.data.aqi);
          setOutdoorPM25(response.data.pm2_5);
          setOutdoorPM10(response.data.pm10);
        }
      } catch (err) {
        console.error("Error fetching outdoor AQI:", err);
      } finally {
        setLoading(false);
      }
    };

    if (city) {
      fetchAQI();
    }
  }, [city]);
  return (
    <div className="Dashboard">
      <div className="row">
      <div
        className="Header col-5"
        style={{ display: "flex", flexDirection: "right" }}
      >
        <div id="CustomerPhoto">
          <img
            className="header-image"
            src="https://picsum.photos/200/300"
            alt="Header Image"
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "30px 30px",
          }}
        >
          <span id="dayTime">Good {Greeting().greeting}!</span>
          <span id="Welcome">
            Welcome <sapn id="UserName">{UserName} !</sapn>
          </span>
        </div>
      </div>
      <div className="Header col-6 mt-3">
        {/* Top AQI Card */}
        <div className="text-center p-3 mb-0">
          <h5 className="mb-0" style={{fontWeight:"bold", color:"#5271ff"}}>Outdoor AQI</h5>
        </div>

        {/* Bottom 3 Small Cards */}
       <div className="row">
        {/* AQI */}
        <div className="col-4">
          <div className="card text-center shadow-lg p-2" style={{ borderRadius: "12px", position: "relative"}}>
            <div style={{ position: "absolute", top: "5px", right: "10px" }}>
              <FaCloud size={32} color="#5271ff"/>
            </div>
            <h6 style={{fontWeight:"bold"}}>AQI</h6>
            {loading ? (
            <div className="d-flex justify-content-center align-items-center mt-2">  
              <div className="spinner-border spinner-border-sm mt-2" style={{color:"#5271ff"}} role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
            ) : (
            <h6 style={{fontWeight:"bold"}} className="mt-2">{outdoorAQI}</h6>
             )}
          </div>
        </div>
        {/* PM2.5 */}
        <div className="col-4">
          <div className="card text-center shadow-lg p-2" style={{ borderRadius: "12px", position: "relative" }}>
            <div style={{ position: "absolute", top: "5px", right: "10px" }}>
              <FaSmog size={32} color="#5271ff" />
            </div>
            <h6 style={{fontWeight:"bold"}}>PM2.5</h6>
            {loading ? (
            <div className="d-flex justify-content-center align-items-center mt-2">  
              <div className="spinner-border spinner-border-sm mt-2" style={{color:"#5271ff"}} role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
            ) : (
            <h6 style={{fontWeight:"bold"}} className="mt-2">{outdoorPM25} µg/m<sup>3</sup></h6>
             )}
          </div>
        </div>

        {/* PM10 */}
        <div className="col-4">
          <div className="card text-center shadow-lg p-2" style={{ borderRadius: "12px", position: "relative" }}>
            <div style={{ position: "absolute", top: "5px", right: "10px" }}>
              <FaWind size={32} color="#5271ff" />
            </div>
            <h6 style={{fontWeight:"bold"}}>PM10</h6>
            {loading ? (
            <div className="d-flex justify-content-center align-items-center mt-2">  
              <div className="spinner-border spinner-border-sm mt-2" style={{color:"#5271ff"}} role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
            ) : (
            <h6 style={{fontWeight:"bold"}} className="mt-2">{outdoorPM10} µg/m<sup>3</sup></h6>
             )}
          </div>
        </div>
      </div>

      </div>
      </div>
      <div className="Navbar" style={{ backgroundColor: "#fff" }}>
        <Tabs
          // defaultActiveKey="dashboard"
          activeKey={key}
          id="uncontrolled"
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="dashboard" title="Dashboard">
            <div className="PageContent"> </div>
            <div className="Dropdown">
              <select onChange={(e) => changeDevice(e)}>
                {dap_deviceList.map((device) => (
                  <option value={device.deviceId} key={device.deviceId}>
                    {device.deviceAlias}
                  </option>
                ))}
              </select>
            </div>
            <div className="row1">
              <div id="rowSection1">
                <div
                  className="Chart"
                  style={{ display: "flex", flexDirection: "right" }}
                >
                  <div className="rowSection1Header">
                    <span id="airQualityTime">
                      Indoor Air Quality at{" "}
                      <span id="Time_color">
                        {time.toLocaleString("en-US", {
                          hour: "2-digit",
                          minute: "numeric",
                          hour12: true,
                        })}
                      </span>
                    </span>
                  </div>

                  <div className="row1Chart">
                    <div className="Donut_Chart">
                      <PieChart width={300} height={300}>
                        <Pie
                          data={data}
                          dataKey="students"
                          outerRadius={100}
                          innerRadius={70}
                          fill={AQIColor}
                          strokeWidth={0}
                        />
                        <text
                          id="AQIVal"
                          x={150}
                          y={140}
                          textAnchor="middle"
                          dominantBaseline="middle"
                        >
                          AQI Value : {AQI}
                        </text>
                        <text
                          id="AqiQuality"
                          x={150}
                          y={170}
                          textAnchor="middle"
                          dominantBaseline="middle"
                          fill={AQIColor}
                        >
                          {AQIquality}
                        </text>
                      </PieChart>
                    </div>
                    <div
                      className="Referance"
                      style={{ marginRight: "70px", marginTop: "60px" }}
                    >
                      {/* <span id="device">Total Devices installed : {Device}</span> */}
                      <div
                        id="Quality"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          id="Good"
                          style={{
                            backgroundColor: "#00B252",
                            marginBottom: 10,
                          }}
                        >
                          Good
                        </div>
                        <div
                          id="Moderate"
                          style={{
                            backgroundColor: "#DF8C0D",
                            marginBottom: 10,
                          }}
                        >
                          Moderate
                        </div>
                        <div
                          id="Poor"
                          style={{
                            backgroundColor: "#D60000",
                            borderradius: "10px",
                          }}
                        >
                          Poor
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rowSection2">
                <div className="rowSection2header">
                  <span>{RmName}</span>
                </div>
                <div className="BestDeviceInfo">
                  <table className="DeviceTable">
                    <tr>
                      <th id="PM-25">
                      PM 2.5
                        <br />
                        <span className="Tc">
                          {dap_pm25} µg/m<sup>3</sup>
                        </span>
                      </th>
                      <th id="PM-10">
                        PM 10
                        <br />
                        <span className="Tc">
                          {dap_pm10} µg/m<sup>3</sup>
                        </span>{" "}
                      </th>
                      <th id="CO2">
                        CO2 <br />
                        <span className="Tc">{dap_co2} PPM</span>
                      </th>
                    </tr>
                    <tr>
                      <th id="TVOC">
                        TVOC <br />
                        <span id="tvoc" className="Tc">
                          {dap_tvoc*1000} PPB
                        </span>
                      </th>
                      <th id="temp">
                        Temperature
                        <br />
                        <span className="Tc">{dap_Temp}°C</span>
                      </th>
                      <th id="HUMY">
                        Humidity
                        <br />
                        <span id="humy" className="Tc">
                          {dap_Humy}%
                        </span>
                      </th>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="row2">
              <div className="EchInfoChart d-flex align-items-center justify-content-between">
              <div style={{ flex: 1, textAlign: 'center' }}>
                <span id="EchInfoChart">
                  Latest 10 Readings of Contaminants
                </span>
              </div>

              {deviceId != null && (
                <div style={{ width: '220px', textAlign: 'right', fontSize: '12px', color: 'GrayText', marginRight: '10px' }}>
                  <b>Last updated</b><br />
                  {lastUpdated}
                </div>
              )}
            </div>
              <div className="DeviceInfoChart">
                <div className="Line1">
                  <div className="Dchart">
                    <span id="span1">
                      <b >
                        PM 2.5: {dap_pm25} µg/m<sup>3</sup>
                      </b>
                    </span>
                    <span className="rmName">{RmName}</span>
                    <Line data={PM25} options={getChartOptions('pm25')} />
                    <div>
                      <span id="span2">X Axis : Time of Latest 10 Readings</span>
                      <span id="span3" style={{ marginLeft: "20px" }}>
                        Y Axis : Pollutant Levels
                      </span>
                    </div>
                  </div>
                  <div className="Dchart">
                    <span id="span1">
                      <b>
                        PM 10: {dap_pm10} µg/m<sup>3</sup>
                      </b>
                    </span>
                    <span className="rmName">{RmName}</span>
                    <Line data={PM10} options={getChartOptions('pm10')} />
                    <div>
                      <span id="span2">X Axis : Time of Latest 10 Readings</span>
                      <span id="span3" style={{ marginLeft: "20px" }}>
                        Y Axis : Pollutant Levels
                      </span>
                    </div>
                  </div>
                  <div className="Dchart">
                    <span id="span1">
                      <b>CO2: {dap_co2} PPM</b>
                    </span>
                    <span className="rmName">{RmName}</span>
                    <Line data={CO2} options={getChartOptions('co2')} />
                    <div>
                      <span id="span2">X Axis : Time of Latest 10 Readings</span>
                      <span id="span3" style={{ marginLeft: "20px" }}>
                        Y Axis : Pollutant Levels
                      </span>
                    </div>
                  </div>
                </div>
                <div className="Line2">
                  <div className="Dchart">
                    <span id="span1">
                      <b>TVOC: {dap_tvoc*1000} PPB</b>
                    </span>
                    <span className="rmName">{RmName}</span>
                    <Line data={TVOC} options={getChartOptions('tvoc')} />
                    <div>
                      <span id="span2">X Axis : Time of Latest 10 Readings</span>
                      <span id="span3" style={{ marginLeft: "20px" }}>
                        Y Axis : Pollutant Levels
                      </span>
                    </div>
                  </div>
                  <div className="Dchart">
                    <span id="span1">
                      <b>Temperature: {dap_Temp}°C</b>
                    </span>
                    <span className="rmName">{RmName}</span>
                    <Line data={TEMP} options={getChartOptions('temp')} />
                    <div>
                      <span id="span2">X Axis : Time of Latest 10 Readings</span>
                      <span id="span3" style={{ marginLeft: "20px" }}>
                        Y Axis : Pollutant Levels
                      </span>
                    </div>
                  </div>
                  <div className="Dchart">
                    <span id="span1">
                      <b>Humidity: {dap_Humy}%</b>
                    </span>
                    <span className="rmName">{RmName}</span>
                    <Line data={HUMY} options={getChartOptions('humy')} />
                    <div>
                      <span id="span2">X Axis : Time of Latest 10 Readings</span>
                      <span id="span3" style={{ marginLeft: "20px" }}>
                        Y Axis : Pollutant Levels
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="historical_data"
            title="Historical Data"
            id="historical_data"
          >
            <div className="row">
              <div className="col-md-8">
                <h6>
                  <b>Choose Devices</b>
                </h6>
                <Select
                  options={dap_deviceList.map((listDevices) => ({
                    value: listDevices.deviceAlias,
                    label: listDevices.deviceAlias,
                  }))}
                  onChange={(e) => {changeDeviceDownload(e); setShowDownload(false);}}
                  value={selectedDevice}
                  placeholder={selectedDevice}
                />
              </div>
            </div>
            <div className="row" style={{ paddingTop: "15px" }}>
              <div className="col-md-4">
                <h6>
                  {" "}
                  <b>From Date</b>
                </h6>
                <span>(dd-mm-yyyy)</span>
                <input
                  type="date"
                  className="form-control"
                  name="start-date"
                  value={startTs}
                  onChange={(e) => {changeFromDate(e); setShowDownload(false);}}
                />
              </div>
              <div className="col-md-4">
                <h6>
                  <b>To Date</b>
                </h6>
                <span>(dd-mm-yyyy)</span>
                <input
                  type="date"
                  className="form-control"
                  name="end-date"
                  value={endTs}
                  onChange={(e) => {changeToDate(e); setShowDownload(false);}}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6" style={{ display: "flex" }}>
                <Button
                  onClick={searchData}
                  style={{ marginTop: "5%", width: "120px", height: "40px" }}
                  disabled={searchLoading}
                >
                  Search{" "}
                  {searchLoading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  {searchLoading && <span></span>}
                  {!searchLoading && <span></span>}
                </Button>
                <div style={{ marginTop: "7%", marginLeft: "2px" }}>
                  <p>
                    <b><i>
                      <span style={{ color: "#80ced6" }}>* </span>For best
                      results please limit your date range to 30 days</i>
                    </b>
                  </p>
                </div>
              </div>
              <div
                className="col-md-2"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginTop: "10px"
                }}
              >
                {showDownload && (
                  <>
                    <CsvDownload
                      style={{ width: "150px", height: "40px" }}
                      className="btn btn-primary add-group-btn"
                      {...csvReport}
                      disabled={convertCsv}
                    >
                      {convertCsv && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      {convertCsv && <span> Exporting to CSV...</span>}
                      {!convertCsv && <span>Download Full Data</span>}
                    </CsvDownload>
                  </>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <h6>
                  <b>Instructions</b>
                </h6>
                <div className="instruction" style={{ paddingLeft: "15px" }}>
                  <ul>
                    <li>
                      Select a Device to Download data for a particular device
                    </li>

                    <li>You can filter the data basis a date range</li>
                  </ul>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="alerts" title="Alerts" id="alert">
            <div
              style={{ margin: "10px auto", width: "420px", minWidth: "120px" }}
            >
              <img
                src={AlertDeviceLogo}
                alt="alert"
                style={{ width: "400px", minWidth: "100px" }}
              />
              <br></br>
              <p
                style={{
                  fontSize: "18px",
                  marginTop: "20px",
                  textAlign: "center",
                }}
              >
                Alerts are triggered when a specific <b>contaminant</b>
                <span> </span><b>surpasses</b> a certain level
              </p>
              <center>
                <button
                  className="log-out-btn"
                  onClick={(e) => setKey("dashboard")}
                  style={{
                    justifyContent: "center",
                    width: "auto",
                    padding: "15px 25px 15px 25px",
                  }}
                >
                  Dashboard
                </button>
              </center>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default CustomerDashboard;
